import { Component, OnInit } from "@angular/core";
import {
  AbstractControl,
  UntypedFormControl,
  UntypedFormGroup,
  Validators,
} from "@angular/forms";
import { Router } from "@angular/router";
import { TranslateService } from "@ngx-translate/core";
import { finalize } from "rxjs/operators";
import { Organization } from "src/app/models/organizations/organization";
import { AuthenticationService } from "src/app/services/authenticate/authentication.service";
import { FirebaseService } from "src/app/services/firebase/firebase.service";
import { LoadingService } from "src/app/services/loading/loading.service";
import { OrganizationService } from "src/app/services/organization/organization.service";

@Component({
  selector: "app-login-page",
  templateUrl: "./login-page.component.html",
  styleUrls: ["./login-page.component.scss"],
})
export class LoginPageComponent implements OnInit {
  public organizations: Organization[] = [];

  lang: string = this.translateService.currentLang;
  is2FAEnabled: boolean = false;

  public form: UntypedFormGroup = new UntypedFormGroup({
    organization: new UntypedFormControl("SKH2", [Validators.required]),
    username: new UntypedFormControl(null, [Validators.required]),
    password: new UntypedFormControl(null, [Validators.required]),
    code: new UntypedFormControl(null, [
      Validators.minLength(6),
      Validators.maxLength(6),
    ]),
  });

  constructor(
    private authService: AuthenticationService,
    private loadingService: LoadingService,
    private firebaseService: FirebaseService,
    private router: Router,
    private organizationService: OrganizationService,
    private translateService: TranslateService,
  ) {}

  setLang(language: string): void {
    this.translateService.use(language).subscribe();
  }

  ngOnInit(): void {
    if (this.authService.isAuthenticated()) {
      this.router.navigate(["/main/overview"]);
      return;
    }

    this.fetch();
  }

  fetch(): void {
    this.loadingService.startLoading();
    this.organizationService
      .getOrganizationList()
      .pipe(finalize(() => this.loadingService.stopLoading()))
      .subscribe({
        next: (response) => (this.organizations = response),
      });
    this.translateService.onLangChange.subscribe((value) => {
      this.lang = value.lang;
      localStorage.setItem("lang", value.lang);
    });
  }

  submit(): void {
    if (this.form.invalid) {
      this.form.markAllAsTouched();
      return;
    }

    this.loadingService.startLoading();
    this.authService
      .signIn({
        organizationCode: "SKH2",
        username: this.form.controls["username"].value,
        password: this.form.controls["password"].value,
        code: this.form.controls["code"].value,
        deviceToken: this.firebaseService.getToken(),
      })
      .pipe(finalize(() => this.loadingService.stopLoading()))
      .subscribe({
        next: (resp) => {
          this.form.reset();
          if (resp.token == null) {
            this.is2FAEnabled = true;
          } else {
            this.router.navigate(["/main/overview"]);
          }
        },
        error: (error) => {
          this.password.setValue(null);
          this.password.setErrors({ wrong: true });
        },
      });
  }

  get organization(): AbstractControl {
    return this.form.controls["organization"];
  }

  get username(): AbstractControl {
    return this.form.controls["username"];
  }

  get password(): AbstractControl {
    return this.form.controls["password"];
  }

  get code(): AbstractControl {
    return this.form.controls["code"];
  }
  get getOrganizations(): { label: string; value: string }[] {
    return this.organizations.map((o) => ({
      label: o.name,
      value: o.code,
      chi: o.name,
      eng: o.engName,
    }));
  }

  _code: string = "";
  check2FA(event: any) {
    if (event.target.value.length > 6) {
      event.target.value = this._code;
      this.code.setValue(this._code);
    } else {
      this._code = event.target.value;
    }
  }
}
